import styles from "../styles/filters-cards-container.module.scss";
import FilterCard from "@/components/pages/home/components/searchbar/components/filter-card";
import $filters, { Filter } from "@/data/filters.constants";
import { useTablet } from "@/hooks/use-responsive";
import { useCategoriesDropdownContext } from "@/components/pages/home/providers/categories-dropdown-provider";

interface FiltersCardsContainerProps {
  onSelectFilter: (filter: Filter) => void;
  selectedFilter: Filter;
  scrollY?: number;
}

const FiltersCardsContainer = ({
  onSelectFilter,
  selectedFilter,
  scrollY,
}: FiltersCardsContainerProps) => {
  const cardFilters = $filters.cardFilters;
  const { isTablet } = useTablet();

  return (
    <div
      className={`${styles.filters_cards_wrapper} ${scrollY && scrollY > getScrollYAdaptiveValue(isTablet) ? styles.hidden : styles.visible}`}
    >
      {cardFilters.map((filter) => (
        <FilterCard
          key={filter.id}
          filter={filter}
          selectedFilter={selectedFilter}
          onSelectFilter={onSelectFilter}
        />
      ))}
    </div>
  );
};

const getScrollYAdaptiveValue = (isTablet: boolean) => {
  return isTablet ? 42 : 90;
};

export default FiltersCardsContainer;
